import styled from 'styled-components';
import indents from '../../constants/js/indents.js';
import fieldStyles from '../../constants/js/fields';
export const StyledFormField = styled.div.withConfig({
  componentId: "FormField__sc-af0zsh-0"
})(["input::-ms-reveal{display:none;}", ""], ({
  isFloatingLabel
}) => isFloatingLabel && 'position: relative;');
export const StyledLabel = styled.div.withConfig({
  componentId: "FormField__sc-af0zsh-1"
})(["margin-bottom:", ";", ""], indents.indentXS, ({
  isFloatingLabel,
  size
}) => isFloatingLabel && `
			z-index: 1;
			position: absolute;
			top: ${indents.indentS};
			left: ${indents.indentS};
			user-select: none;
			pointer-events: none;
			left: 0
			margin: 0;
			top: ${size === 'lightL' && '29px' || size === 'lightM' && '24px' || size === 'lightS' && '21px' || size === 'lightXS' && '18px' || '16px'};
	`);
export const StyledStatusMessage = styled.div.withConfig({
  componentId: "FormField__sc-af0zsh-2"
})(["margin-top:", ";color:", ";font-size:", ";line-height:", ";", " ", " ", ""], fieldStyles.bottomTextHint.topIndent, fieldStyles.bottomTextHint.themes.light.default, fieldStyles.bottomTextHint.fontSize, fieldStyles.bottomTextHint.fontSize, ({
  status
}) => status.type === 'valid' && `color: ${fieldStyles.bottomTextHint.themes.light.valid};` || status.type === 'error' && `color: ${fieldStyles.bottomTextHint.themes.light.error};` || status.type === 'warning' && `color: ${fieldStyles.bottomTextHint.themes.light.warning};`, ({
  skin
}) => skin === 'dark' && `color: ${fieldStyles.bottomTextHint.themes.dark.default};`, ({
  isDisabled,
  skin
}) => isDisabled && `color: ${fieldStyles.bottomTextHint.themes.light.disabled};` || isDisabled && skin === 'dark' && `color: ${fieldStyles.bottomTextHint.themes.dark.disabled};`);